import { render } from "./Blob.vue?vue&type=template&id=39774f15&scoped=true&ts=true"
import script from "./Blob.vue?vue&type=script&lang=ts"
export * from "./Blob.vue?vue&type=script&lang=ts"

import _style_0 from "./Blob.vue?vue&type=style&index=0&id=39774f15&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-39774f15"]])

export default __exports__